import React from 'react'

type ErrorBoundaryProps = {
  fallback: React.ReactNode
  apiPrefix?: string
  httpClient?: <T>(url: string, options?: RequestInit) => Promise<T>
}

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error, errorInfo)
    if (this.props.httpClient) {
      try {
        this.props.httpClient((this.props.apiPrefix ?? '') + 'logging/error', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: error.message, url: window.location.href }),
        })
      } catch (e) {
        console.error(e)
      }
    }
  }

  render() {
    const { fallback, children } = this.props

    return this.state.hasError ? fallback : children
  }
}

export default ErrorBoundary
